import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { CartProvider } from './context/CartContext';
import { Home } from './pages/Home';
import { Store } from './pages/Store';
import { CartPage } from './pages/CartPage';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { ProductDetail } from './pages/ProductDetail';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminAnalytics } from './pages/AdminAnalytics';
import { AdminProducts } from './pages/AdminProducts';
import { DrinkCalculatorPage } from './pages/DrinkCalculatorPage';
import { authService } from './services/authService';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  if (!authService.isLoggedIn()) {
    return <Navigate to="/admin/login" />;
  }
  return <>{children}</>;
};

export const App = () => {
  return (
    <Router>
      <CartProvider>
        <div className="min-h-screen bg-gradient-to-br from-mdm-pink/5 to-mdm-blue/5">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/store" element={<Store />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/products"
              element={
                <PrivateRoute>
                  <AdminProducts />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/analytics"
              element={
                <PrivateRoute>
                  <AdminAnalytics />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/drink-calculator"
              element={
                <PrivateRoute>
                  <DrinkCalculatorPage />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </CartProvider>
    </Router>
  );
};